import { css } from "@emotion/css";

export const logoGradientTextCSS = css`
  background-image: linear-gradient(to right, #db392e, #b12338);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

export const headerCSS = css`
  box-shadow: 0px 1px 5px 0px rgba(18, 19, 21, 0.18);
  height: 52px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  color: #e50000;
  font-weight: 600;
  font-size: 20px;
  font-family: Roboto;
  width: 100%;
  background-color: #fff;
  z-index: 99;
`;

export const draggableCSS = css`
  cursor: move;
`;

export const betaTagCSS = css`
  font-size: 12px;
  background-color: #e1e2e5;
  border-radius: 9px;
  padding: 0 8px;
  color: #54575d;
  font-family: Roboto;
  font-weight: 300;
  height: 17px;
  line-height: 17px;
  margin-left: 12px;
`;

export const headerIconsContainerCSS = css`
  margin-left: auto;
  margin-right: -16px;
  display: flex;
  gap: 10px;
`;

export const headerIconButtonCSS = css`
  &&.spark-btn--icon {
    font-size: 24px;
    width: 36px;
    height: 36px;
    padding: 0;
  }
`;
